<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-card class="mb-3" title="Kategori Listesi">
          <b-alert variant="warning" show class="mb-0">
            <div class="alert-body mb-2">
              <span
                ><strong>Not:</strong> Eklenecek kategori adı ve arama motoru bağlantı
                linki benzersiz olmalıdır...</span
              >
            </div>
          </b-alert>
          <b-button
            class="float-right"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            to="/categories/create"
          >
            Yeni Kategori Ekle
          </b-button>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <b-card class="mb-3" title="Kategoriler">
          <b-form>
            <b-row>
              <b-col cols="12">
                <Draggable
                  :indent="50"
                  :treeData="categoriesTree"
                  @drop-change="outputNestedData"
                >
                  <template v-slot="{ node }">
                    <b-card
                      :border-variant="'primary'"
                      bg-variant="transparent"
                      class="shadow-none draggable-card"
                    >
                      <b-row>
                        <b-col cols="6">
                          <b-card-text
                            class="font-weight-bold mb-0"
                            style="line-height: 36px"
                          >
                            {{ node.text }}
                          </b-card-text>
                        </b-col>
                        <b-col cols="6">
                          <div class="float-right">
                            <b-button-group>
                              <b-button
                                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                                variant="outline-danger"
                                class="btn-icon rounded-circle"
                                @click="deleteConfirmText(node.id)"
                              >
                                <feather-icon icon="TrashIcon" />
                              </b-button>
                            </b-button-group>
                          </div>
                          <div class="float-right mr-2">
                            <b-button-group>
                              <b-button
                                v-for="language in languages"
                                :key="language.locale"
                                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                                :variant="
                                  node.languages.find(
                                    (element) => element == language.locale
                                  )
                                    ? 'outline-warning'
                                    : 'outline-secondary'
                                "
                                :title="
                                  node.languages.find(
                                    (element) => element == language.locale
                                  )
                                    ? 'Düzenle'
                                    : 'Ekle'
                                "
                                @click="action(node, language.locale)"
                              >
                                {{ language.locale.toUpperCase() }}
                              </b-button>
                            </b-button-group>
                          </div>
                          <div class="float-right mr-2">
                            <b-badge v-if="node.isDraft == false" variant="light-success">
                              Yayında
                            </b-badge>
                            <b-badge v-if="node.isDraft == true" variant="light-warning">
                              Taslakta
                            </b-badge>
                          </div>
                        </b-col>
                      </b-row>
                    </b-card>
                  </template>
                </Draggable>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Ripple from "vue-ripple-directive";
import "he-tree-vue/dist/he-tree-vue.css";
import { BaseTree, Draggable } from "@he-tree/vue2";
import {
  BRow,
  BCol,
  BImg,
  BCard,
  BForm,
  BBadge,
  BAlert,
  BButton,
  BAvatar,
  BCardText,
  BButtonGroup,
  BListGroupItem,
  BButtonToolbar,
} from "bootstrap-vue";

import { Endpoints } from "@core/endpoints/endpoints";
const endpoints = new Endpoints();

export default {
  components: {
    BRow,
    BCol,
    BImg,
    BCard,
    BForm,
    BBadge,
    BAlert,
    BButton,
    BAvatar,
    BCardText,
    BButtonGroup,
    BListGroupItem,
    BButtonToolbar,
    BaseTree,
    Draggable,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      request: [],
      languages: [],
      categories: [],
      categoriesTree: [],
      categoriesTreeOrder: [],
      categoriesTreeOutput: [],
    };
  },
  watch: {},
  methods: {
    action(node, locale) {
      let translationControl = node.languages.find((element) => element == locale);

      if (translationControl == undefined) {
        this.$router.push({
          path: `/categories/create/translation/${node.id}?targetLocale=${locale}`,
        });
      } else {
        this.$router.push({
          path: `/categories/edit/${node.slugs[locale]}?targetLocale=${locale}`,
        });
      }
    },

    flatten(nodeList, parentId) {
      nodeList.forEach((node) => {
        this.categoriesTreeOrder.push({
          slug: node.slug,
          parentId: parentId,
        });
        if (node.children.length > 0) {
          this.flatten(node.children, node.id);
        }
      });
    },
    outputNestedData(e) {
      this.categoriesTreeOutput = e.targetTree.outputNestedData();
      this.updateSubmit();
    },
    updateSubmit() {
      this.request = [];
      this.categoriesTreeOrder = [];
      this.flatten(this.categoriesTreeOutput, null);
      Object.entries(this.categoriesTreeOrder).forEach(([key, value]) => {
        let categoryOrder = {
          parentId: value.parentId,
          slug: value.slug,
          order: parseInt(key),
        };
        this.request.push(categoryOrder);
      });
      endpoints
        .putCategoriesOrder({ categories: this.request }, this.$i18n.locale, () => {})
        .then((data) => {
          this.$swal({
            icon: "success",
            title: "Güncelleme başarılı!",
            text: "Kategori sıralaması güncellendi.",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getCategories() {
      endpoints
        .getCategories(null, this.$i18n.locale, () => {})
        .then((data) => {
          this.categories = [];
          this.categories = [...data.response];
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getLanguages() {
      endpoints
        .getLanguages(null, this.$i18n.locale, () => {})
        .then((data) => {
          this.languages = [...data.response];
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getCategoriesTree() {
      endpoints
        .getCategoriesTree(null, this.$i18n.locale, () => {})
        .then((data) => {
          this.categoriesTree = [];
          this.categoriesTree = [...data.response];
          this.flatten(this.categoriesTree, null);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    deleteConfirmText(id) {
      this.$swal({
        title: "Sil?",
        text: "Kategoriyi silmek istediğinize emin misiniz?",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "Vazgeç!",
        confirmButtonText: "Kaydet!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.deleteSubmit(id);
        }
      });
    },
    deleteSubmit(id) {
      endpoints
        .deleteCategories(id, this.$i18n.locale, () => {})
        .then((data) => {
          this.getCategories();
          this.getCategoriesTree();
          this.$swal({
            icon: "success",
            title: "Silme başarılı!",
            text: "Kategori silindi",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  mounted() {
    this.getLanguages();
    this.getCategories();
    this.getCategoriesTree();
  },
};
</script>
<style>
.draggable-card {
  margin-bottom: 0;
}
.draggable-card > .card-body {
  padding: 10px;
}

.draggable-card > .card-body > .card-title {
  margin-bottom: 0;
  font-size: 1rem;
}
.tree-node {
  border: 0 !important;
}
</style>
